import * as types from './actionTypes';
import axios from 'axios';
import { setGlobalErrors } from './globalErrorActions';
import { getHeader, getMessageByErrorStatus } from '../helper';

function getNewsRequest() {
    return {
        type: types.LOAD_NEWS_REQUEST
    }
}

function getNewsSuccess(data) {
    return {
        type: types.LOAD_NEWS_SUCCESS,
        data: data
    }
}

function getNewsError(messages) {
    return {
        type: types.LOAD_NEWS_FAILURE,
        messages
    }
}

export function getNews() {
    
    return function (dispatch) {
        dispatch(getNewsRequest());
        dispatch(setGlobalErrors('news', {}));

        return axios.get(`${window.siteUrl}/api/v1/news/`,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(getNewsSuccess(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getNewsError", err.data, err.status, err.headers);
                dispatch(getNewsError(err.data));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('news', {status: err.status, error: errorText}));
            }
        });
    }
}

function getMoreNewsRequest() {
    return {
        type: types.LOAD_MORE_NEWS_REQUEST
    }
}

function getMoreNewsSuccess(data) {
    return {
        type: types.LOAD_MORE_NEWS_SUCCESS,
        data: data
    }
}

function getMoreNewsError(messages) {
    return {
        type: types.LOAD_MORE_NEWS_FAILURE,
        messages
    }
}

export function getMoreNews(next) {
    
    return function (dispatch) {
        dispatch(getMoreNewsRequest());
        dispatch(setGlobalErrors('news', {}));
        
        return axios.get(next,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(getMoreNewsSuccess(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getMoreNewsError", err.data, err.status, err.headers);
                dispatch(getMoreNewsError(err.data));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('news', {status: err.status, error: errorText}));
            }
        });
    }
}

function getItemNewsRequest() {
    return {
        type: types.LOAD_ITEM_NEWS_REQUEST
    }
}

function getItemNewsSuccess(data) {
    return {
        type: types.LOAD_ITEM_NEWS_SUCCESS,
        data: data
    }
}

function getItemNewsError(messages) {
    return {
        type: types.LOAD_ITEM_NEWS_FAILURE,
        messages
    }
}

export function getItemNews(id) {
    
    return function (dispatch) {
        dispatch(getItemNewsRequest());
        dispatch(setGlobalErrors('news', {}));

        return axios.get(`${window.siteUrl}/api/v1/news/${id}/`,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(getItemNewsSuccess(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getItemNewsError", err.data, err.status, err.headers);
                dispatch(getItemNewsError(err.data));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('news', {status: err.status, error: errorText}));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/newsActions.js